import { useIntl } from '@capsicum/common';
import { GenericDrawer, useGoatImage } from '@capsicum/common-web';

export type RevokeConsentsModalProps = {
	onButtonPress: () => void;
	onSecondaryActionOnButtonPress: () => void;
	testID: string;
};

export const RevokeConsentsModal = ({
	onButtonPress,
	onSecondaryActionOnButtonPress,
	testID
}: RevokeConsentsModalProps) => {
	const { $t } = useIntl();
	const goatAnkwardImage = useGoatImage('alert');

	const revokeConsentsDrawerData = {
		buttonText: $t('settings.accountManagement.consentsRevokeAccept'),
		description: $t('settings.accountManagement.consentRevokeDescription'),
		image: goatAnkwardImage,
		imageSize: { height: 220, width: 300 },
		isButtonOnRow: false,
		onButtonPress,
		onSecondaryActionOnButtonPress,
		secondaryActionButtonText: $t('settings.accountManagement.consentRevokeCancel'),
		testID: testID
	};

	return <GenericDrawer {...revokeConsentsDrawerData}></GenericDrawer>;
};
